import React from 'react'
import image from '../assets/about.png'
import Slider from './Slider'

const AboutComponent = () => {
  return (
    <div className='w-full flex flex-col justify-center items-center pb-[20vh]'>
      <div className="w-full h-[80vh] flex items-center flex-col overflow-hidden">
        <img src={image} alt="" className=' absolute left-0 top-0 h-[40vh] w-full' />
        <h1 className='text-[#696969] font-semibold font-outfit md:text-3xl mt-[25vh] lg:mt-[50vh] text-2xl w-[65%] text-center drop-shadow-xl lg:drop-shadow-none'> <h1 className='text-4xl font-bold inline'> ROOTS </h1>  is the Creative Confluence of NIT Rourkela dedicated to let you explore the creative spark in you!</h1>
      </div>
      <Slider />
    </div>
  )
}

export default AboutComponent